// extracted by mini-css-extract-plugin
export default {"subHeader":"TmF1m","challengeTopContainer":"Nsyd0","topListContainer":"PaDk4","linkText":"CG99B"};